import { signal } from '@preact/signals';

type LayoutType = 'full' | 'standalone';

export default function createLayoutStore() {
    return {
        title: signal<string>(''),
        extraTitle: signal<string>(''),
        subtitle: signal<string>(''),
        description: signal<string>(''),
        type: signal<LayoutType>('full'),
    };
}
